import React from "react";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Nivel from "./Nivel";
import Bomba from "./Bomba";
import Pressao from "./Pressao";
import Vazao from "./Vazao";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      json: { nivel: [], bomba: [], pressao: [], vazao: [] },
      loading: true,
      error: null,
    };
    this.buttonLoading = this.buttonLoading.bind(this);
    this.callApi = this.callApi.bind(this);
  }
  async componentDidMount() {
    this.setState({
      loading: true,
      error: null,
    });
    await this.callApi();
    setInterval(async () => {
      this.setState({
        loading: true,
        error: null,
      });
      await this.callApi();
    }, 1000 * 60);
  }
  async callApi() {
    const API = process.env.REACT_APP_URL_API;
    const SERVER = process.env.REACT_APP_URL_SERVER;

    // Verificar se as variáveis de ambiente estão definidas
    if (!API) {
      this.setState({
        loading: false,
        error:
          "Erro de configuração: A variável REACT_APP_URL_API não está definida. Verifique o arquivo .env",
      });
      return;
    }

    if (!SERVER) {
      this.setState({
        loading: false,
        error:
          "Erro de configuração: A variável REACT_APP_URL_SERVER não está definida. Verifique o arquivo .env",
      });
      return;
    }

    try {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      headers.append("Origin", SERVER);

      const response = await fetch(API, {
        mode: "cors",
        method: "GET",
        headers: headers,
      });

      // Verificar se a resposta está ok
      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status} ${response.statusText}`);
      }

      const json = await response.json();

      this.setState({
        json,
        loading: false,
        error: null,
      });
    } catch (error) {
      console.error("Erro ao buscar dados da API:", error);
      this.setState({
        loading: false,
        error: `Erro ao conectar com a API: ${error.message}. Verifique se a API está acessível e se as configurações de CORS estão corretas.`,
      });
    }
  }
  buttonLoading() {
    return (
      <Button variant="primary" disabled>
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />
        Carregando...
      </Button>
    );
  }
  render() {
    const { loading, error } = this.state;
    const { nivel, bomba, pressao, vazao } = this.state.json;
    return (
      <main className="text-center justify-content-between">
        {loading ? this.buttonLoading() : ""}
        {error && (
          <div className="container mt-3">
            <Alert variant="danger">
              <Alert.Heading>Erro ao carregar dados</Alert.Heading>
              <p>{error}</p>
            </Alert>
          </div>
        )}
        {!error && nivel && nivel.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Níveis</h4>
            <Nivel nivel={nivel} />
          </div>
        ) : (
          <div></div>
        )}
        {!error && bomba && bomba.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Bombas</h4>
            <Bomba bomba={bomba} />
          </div>
        ) : (
          <div></div>
        )}
        {!error && pressao && pressao.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Medidores de Pressão</h4>
            <Pressao pressao={pressao} />
          </div>
        ) : (
          <div></div>
        )}
        {!error && vazao && vazao.length > 0 ? (
          <div className="container">
            <h4 className="card-title">Medidor de Vazão</h4>
            <Vazao vazao={vazao} />
          </div>
        ) : (
          <div></div>
        )}
      </main>
    );
  }
}

export default Main;
